import React, { Component } from 'react';
import Sketch, { AvailableOptionTypes } from '../../../sketch/Sketch';
import { showPrompt } from '../../../helpers/MessageUtility';

export interface SketchCanvasProps {
  w?: number;
  h?: number;
  align?: string;
  value?: string;
  sasToken?: TypeMePlease;
  fileUrls?: TypeMePlease;
  onAvailableOptionsChanged: (name: AvailableOptionTypes, value: boolean) => void;
}

export default class SketchCanvas extends Component<SketchCanvasProps, TypeMePlease> {
  private sketch: Sketch;
  private canvas: TypeMePlease;

  constructor(props) {
    super(props);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.bringForward = this.bringForward.bind(this);
    this.sendBackwards = this.sendBackwards.bind(this);
  }

  componentDidMount() {
    this.sketch = new Sketch(this.canvas, this.props.w, this.props.h, this.props.align, this.props.onAvailableOptionsChanged, showPrompt);
    this.setBackgroundImage();
    this.sketch.setValue(this.props.value);
    document.body.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(e) {
    if (e.keyCode === 46 || e.keyCode === 8) {
      this.sketch.onDeleteObject();
    }
  }

  getValue() {
    return this.sketch.getValue();
  }

  setTool(tool) {
    this.sketch.setMode(tool);
  }

  bringForward() {
    this.sketch.bringForward();
  }

  sendBackwards() {
    this.sketch.sendBackwards();
  }

  setColor(color) {
    this.sketch.setStrokeColor(color);
  }

  setSize(size) {
    this.sketch.setObjectScale(size);
  }

  deleteSelectedObject() {
    this.sketch.onDeleteObject();
  }

  openTextPromptForCurrentSelection() {
    this.sketch.openTextPromptForCurrentSelection();
  }

  deleteAllObjects() {
    this.sketch.onDeleteAllObjects();
  }

  resize(w: number) {
    this.sketch.resize(w);
  }

  setBackgroundImage(fileId?) {
    let filePath = '';
    let imageUrl = null;
    let imageFileId = null;
    if (this.props.value) {
      const properties = JSON.parse(this.props.value);
      filePath = properties.FileId;
      imageFileId = properties.FileId;
      if (this.props.fileUrls) {
        imageUrl = this.props.fileUrls[properties.FileId];
      }
    }
    if (fileId) {
      filePath = fileId;
      imageFileId = fileId;
      if (this.props.fileUrls) {
        imageUrl = this.props.fileUrls[fileId];
      }
    }

    if (filePath && !imageUrl) {
      imageUrl = `${this.props.sasToken.baseUrl}${filePath}${this.props.sasToken.token}`;
    }
    this.sketch.setBackgroundImage(imageFileId, imageUrl);
  }

  clearBackgroundImage() {
    this.sketch.clearBackgroundImage();
  }

  undo() {
    this.sketch.undo();
  }

  redo() {
    this.sketch.redo();
  }

  render() {
    return (
      <canvas
        id="sketchCanvas"
        width={this.props.w}
        height={this.props.h}
        style={{ width: `${this.props.w}px`, height: `${this.props.h}px` }}
        ref={(r) => {
          this.canvas = r;
        }}
      />
    );
  }
}
